import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDibIconExcel = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 26.5 24.9",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 16.3,
			y: 3.3,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			width: 9.4,
			height: 18.3
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			children: [
				/* @__PURE__ */ _jsx("line", {
					x1: 23,
					y1: 7.7,
					x2: 19.1,
					y2: 7.7
				}),
				/* @__PURE__ */ _jsx("line", {
					x1: 23,
					y1: 10.9,
					x2: 19.1,
					y2: 10.9
				}),
				/* @__PURE__ */ _jsx("line", {
					x1: 23,
					y1: 14,
					x2: 19.1,
					y2: 14
				}),
				/* @__PURE__ */ _jsx("line", {
					x1: 23,
					y1: 17.2,
					x2: 19.1,
					y2: 17.2
				})
			]
		}),
		/* @__PURE__ */ _jsx("polygon", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			points: "0.8,3.9 0.8,21 16.3,24 16.3,0.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "none",
			fill: "currentColor",
			d: "M12.9,17.1h-2.2l-2.2-3.5l-2.2,3.5H4.2l3.1-4.8L4.4,7.8h2.2l2,3.3l2-3.3h2.1l-2.9,4.6L12.9,17.1z"
		})
	]
});
export default SvgDibIconExcel;
